module.exports = __webpack_public_path__ + "img/ABLFrictionDetailed-min.b5c73a4e.png";